import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import ViewDetailsButton from "../ActionsButtons";

function AuditTableRow({ row }) {
  return (
    <>
      <TableRow sx={{'&:last-child th': {border: 0}}}>
        <TableCell>{row.id}</TableCell>
        <TableCell>{new Date(row.ctime).toLocaleString().replace(',', '')}</TableCell>
        <TableCell>{row.actionType}</TableCell>
        <TableCell>{row.dataType}</TableCell>
        <TableCell>{row.changedByUser ?? ''}</TableCell>
        <TableCell style={{paddingTop: '3px', paddingBottom: '3px'}}><ViewDetailsButton data={row} /></TableCell>
      </TableRow>
    </>
  );
}

export default AuditTableRow;
